<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 font-45 colorPrincipal">
            EL ARTE DEL POETA <br> JOSÉ MARÍA EGUREN <br>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio8/artePoeta">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio8/artePoeta">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio8/artePoeta">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img width="100%" src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU_IMG001.jpg">
</section>
<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-center font-24">
                    LA POESÍA DE JOSÉ MARÍA EGUREN (1874-1942) ES UNA DE LAS MÁS RELEVANTES DE LA LITERATURA PERUANA
                    CONTEMPORÁNEA.
                    <br>
                </p>
                <p class="fontMS100 text-justify font-24">
                    <br>
                    Los estudiosos de su obra señalan su vínculo con el simbolismo francés, pero reconocen en ella una 
                    propuesta original, un universo de imágenes, figuras y color, evocaciones, recuerdos y ensueños. 
                    El poeta también practicó la pintura, el dibujo, la acuarela y la fotografía, lo que señala su 
                    inquietud por desarrollar varios géneros, técnicas y estilos de creación artística.
                    <br><br>
                </p>
                <p class="text-center">
                    <img class="imgNP" width="30%"
                        src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU_IMG002.jpg">
                </p>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-2">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU__LINEA1-recortado3.png">
                    </div>
                    <div class="col-sm-8">
                        <p style="line-height: 100%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal2 font-40">
                            EL ESPEJO LUMINOSO DEL RECUERDO
                        </p>
                    </div>
                    <div class="col-sm-2">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU__LINEA1-recortado3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS300 text-center colorPrincipal2 font-40">
                    MINIATURAS FOTOGRÁFICAS
                </p>
                <p class=" fontMS300 text-white text-center textUpper font-24">
                    <br>
                    HACIA LA DÉCADA DE 1920, JOSÉ MARÍA EGUREN INICIA SU FACETA DE FOTÓGRAFO, 
                    CUYA OBRA ESTÁ REUNIDA, EN PARTE, EN EL ÁLBUM QUE CUSTODIA LA BIBLIOTECA 
                    NACIONAL DEL PERÚ, EL CUAL FUE DECLARADO PATRIMONIO CULTURAL DE LA NACIÓN POR EL MINISTERIO DE CULTURA.
                    <br>
                </p>
                <p class="fontMS100 text-white text-justify font-24">
                    <br>
                    Esta colección contiene 525 fotografías dispuestas en grupos de diez fotos en cada hoja a excepción 
                    de la penúltima que posee solo cinco. Sus tamaños tienen un promedio de 2.5 x 3 cm. Para lograr estas 
                    capturas, Eguren diseñó una pequeña cámara utilizando un tintero que, a través de un pequeño orificio, 
                    permitía el ingreso de luz que fijaba la imagen en un elemento fotosensible.
                    <br><br>
                    La mayor parte de sus miniaturas están distribuidas entre retratos, animales de los zoológicos que 
                    existían en el Parque de la Exposición y en el distrito de Barranco, animales domésticos, edificaciones, 
                    playas y bañistas de Lima. Las fotografías en tonos azules podrían haber sido realizados mediante el 
                    proceso de la cianotipia o aplicando en el fijador pequeños trozos de hierro oxidado. Otro grupo lo 
                    constituyen las fotos de muñecas a manera de retratos surrealistas y la experimentación con el juego 
                    de luces y sombras para lograr atmósferas misteriosas.
                    <br>
                </p>
                <p class="text-center">
                    <img src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU_IMG003.png" width="80%">
                </p>
                <a href="http://hdl.handle.net/20.500.14428/79179"
                    target="_blank" style="color: black;">
                    <p class="text-left">
                        <img src="/assets/images/micrositio/micrositio8/LIBRO1.jpg" width="30%">
                    </p>
                </a>
                <p class="text-left">
                    <br>
                    <img src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU__LINEA2.jpg" width="100%">
                    <br><br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS700 font-40 colorPrincipal2">
                            PINTURAS, ACUARELAS Y DIBUJOS </p>
                    </div>
                    <div class="col-sm-6">
                        <img class="LineSubsec_Izq"
                            src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU__LINEA1-recortado.png"
                            width="100%">
                    </div>
                </div>
                <p class="fontMS100 text-white text-justify font-24">
                    <br>
                    En una entrevista con el pintor Teófilo Castillo en 1919 y publicada en la revista  <span
                        class="fontMS100Italic">Variedades</span>, José María Eguren indica su preferencia por todos los 
                    géneros de la pintura, sin embargo, hace énfasis en el paisaje. Hacia 1928, en una carta a José Carlos 
                    Mariátegui le confiesa que no ilustraba sus versos por temor a “limitarlos” y le adelanta que venía 
                    trabajando en un conjunto de “acuarelas imaginadas”.
                    <br><br>
                    En 1963, fueron donadas por Luis Alayza Paz Soldán a la Biblioteca Nacional del Perú, 189 piezas entre 
                    pinturas, acuarelas y dibujos, junto a la biblioteca personal de José María Eguren. El conjunto de su 
                    arte es un universo de imágenes de penetrante carga simbólica, de paisajes, figuras femeninas y animales, 
                    amaneceres y crepúsculos, siluetas y representaciones arquitectónicas de gran poder evocador y aura de misterio.
                    <br><br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS100Italic text-white font-24 text-right">
                            La línea es emoción y belleza. Simple y paradojal, une y separa;
                            es limitación e infinitud. Alegre cuando asciende,
                            sufre cuando se curva e inclina. La línea es la forma,
                            que contiene el espíritu; la prisión extraña que Plotino miraría de espanto.
                            La recta es una liberación, una senda al infinito.
                            Siempre ignoraremos su punto de llegada y el significado de la
                            forma en que se resuelve.


                        </p>
                        <p class="fontMS100Italic text-white font-24 text-right">
                            José María Eguren. Motivos.
                            <br><br>
                        </p>
                        <p>
                            <a href="http://hdl.handle.net/20.500.14428/79598"
                                target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio8/LIBRO2.jpg" width="40%">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p>
                            <img class="p-1 imgNP" src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU_IMG004.jpg"
                                width="40%">
                            <img class="p-1 imgNP" src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU_IMG005.jpg"
                                width="40%">
                        </p>
                    </div>
                    <div class="col-sm-12 mb-4">
                        <img src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU__LINEA2.jpg" width="20%">
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100Italic text-white font-24 text-right">
                            <span class="fontMS100">
                                A partir de su adolescencia, Eguren reside en el distrito limeño de Barranco. 
                                Allí realiza incursiones hacia la playa y hacia los acantilados de Chorrillos 
                                para pintar el vaivén de las olas contra las rocas.
                            </span>
                            <br><br>
                            La naturaleza supera al arte en extensión, luz y perfume.
                            Nunca se logrará pintar el mar perfecto;
                            pero el arte es el alma misma del hombre.
                        </p>
                        <p class="fontMS100Italic text-white font-24 text-right">
                            José María Eguren. Motivos.
                            <br><br> <br><br> <br><br>
                        </p>
                        <p>

                            <a href="http://hdl.handle.net/20.500.14428/79599"
                                target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio8/LIBRO2.jpg" width="40%">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p>
                            <img class="p-1 imgNP"
                                src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU_IMG008a.jpg" width="80%">
                            <img class="p-1 imgNP"
                                src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU_IMG009a.jpg" width="80%">
                        </p>
                    </div>
                    <div class="col-sm-12 mb-4">
                        <img src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU__LINEA2.jpg" width="20%">
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100Italic text-white text-right font-24 ">
                            Organiza un mundo con sus figuras, las dota de un ambiente propio y
                            las mueve dentro de una lógica exclusivamente suya para arrastra al
                            lector hasta ese mundo y hacerle en él la revelación de sus quimeras
                            que son toda su alma y toda su vida.
                        </p>
                        <p class="fontMS100Italic text-white font-24 text-right">
                            Alberto Ureta (1929).
                            <br><br>
                        </p>
                        <p>
                            <a href="http://hdl.handle.net/20.500.14428/79597"
                                target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio8/LIBRO2.jpg" width="40%">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p>
                            <img class="p-1  imgNP"
                                src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU_IMG013a.jpg" width="40%">
                            <img class="p-1 imgNP"
                                src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU_IMG014a.jpg" width="40%">
                        </p>
                    </div>
                    <div class="col-sm-12 mb-4">
                        <img src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU__LINEA2.jpg" width="20%">
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100Italic text-white text-right font-24">
                            La delicadeza sintetiza lo bello.
                        </p>
                        <p class="fontMS100Italic text-white font-24 text-right">
                            José María Eguren. Motivos.
                            <br><br>
                        </p>
                        <p>
                            <br><br> <br><br> <br><br> <br><br> <br><br><br><br><br><br>
                            <a href="http://hdl.handle.net/20.500.14428/79600"
                                target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio8/LIBRO2.jpg" width="40%">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p>
                            <img class="p-1 imgNP"
                                src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU_IMG017a.jpg" width="80%">
                            <img class="p-1 imgNP"
                                src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU_IMG018a.jpg" width="80%">
                        </p>
                    </div>
                    <div class="col-sm-12 mb-4">
                        <img src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU__LINEA2.jpg" width="20%">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" width="100%">
                <p class="text-justify fontMS500 font-24">
                    <br>
                    <span>
                        LAS VISIONES DE JOSÉ MARÍA EGUREN ESTÁN ABIERTAS A LÍMITES INEXPLICABLES. SU POESÍA, SIEMPRE TAN
                        ABSOLUTAMENTE NUEVA, VIVE EN EL MUNDO DE LO FABULOSO, PERO SIEMPRE DECANTADO POR UNA PUPILA
                        VIRGINAL. DE AHÍ SU TRASCENDENCIA, SU IMPLACABLE HUMANIDAD Y RIQUEZA DE EXPERIENCIA; SUS
                        ESENCIAS ONÍRICAS, SU ESTRICTA SOLEDAD. SU POESÍA FLUYE CALIDAD Y DELICADEZA, A TODO LLEGA POR
                        SORTILEGIO, POR MARAVILLA, POR MAGIA; LLEVA EL IDIOMA AL MUNDO DEL SUEÑO ORIGINAL, SIN RETÓRICA
                        U HOJARASCAS VERBALES, PLENO DE IMAGINACIÓN Y DE MÚSICA.
                    </span>
                </p>
                <p class="text-right fontMS300Italic font-24">
                    <span>
                        ROCÍO SILVA-SANTISTEBAN, 1992.
                    </span>
                    <br>
                </p>
                <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" class="reflejo"
                    width="100%">
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-6">
                        <p style="line-height: 190%;margin-bottom: 0%;" class="fontMS700 colorPrincipal font-40">
                            EL RECONOCIMIENTO
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <img class="LineSubsec_Izq"
                            src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU__LINEA1-recortado2.png"
                            width="100%">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS500 colorPrincipal font-40">
                    AL POETA
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            Dos grandes hombres, venidos de vertientes diferentes, como son el gran literato Abraham 
                            Valdelomar (1888-1919) y el intelectual José Carlos Mariátegui (1894-1930) supieron comprender 
                            la importancia de la obra de Eguren como fuente para la renovación de las letras peruanas. 
                            Por tal razón, le dedicaron parte de la edición de las revistas que ellos dirigían, las cuales 
                            representaron publicaciones de gran influencia en la historia cultural del siglo XX.
                            <br><br>
                            Valdelomar fundó la revista <span class="fontMS100Italic">Colónida</span> (1916) con la premisa de 
                            innovar el rígido academicismo de la literatura peruana. Las cuatro ediciones de la publicación 
                            aparecieron en 1916 y el número 2 (que tuvo un retrato de José María Eguren en su portada) fue 
                            fundamental para el reconocimiento y difusión de su poesía.
                            <br><br>
                            En tanto, la revista <span class="fontMS100Italic">Amauta</span> se publicó entre 1926 a 1930 y fue un 
                            hito intelectual y cultural en Iberoamérica. Mariátegui, su fundador y director, dedicó el número 23 
                            como homenaje a la prosa, estética y poesía de Eguren.
                            <br><br>
                        </p>
                        <div class="row">
                            <img src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU__LINEA2.jpg" width="100%">
                            <div class="col-sm-2">
                                <a href="http://hdl.handle.net/20.500.14428/79621"
                                    target="_blank" style="color: inherit; text-decoration:none;">
                                    <i class="fas fa-file-alt font-24 p-3"></i>
                                </a>
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-24">
                                    <a href="http://hdl.handle.net/20.500.14428/79621"
                                        target="_blank" style="color: inherit; text-decoration:none;">
                                        REVISTA CÓLONIDA N°2<br>
                                        Enrique A. Carrillo. "Ensayo sobre José María Eguren".
                                    </a>
                                </p>
                            </div>
                            <img src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU__LINEA2.jpg" width="100%">
                        </div>
                        <!-- <div class="row">
                            <div class="col-sm-2">
                                <a href="" target="_blank" style="color: inherit; text-decoration:none;">

                                <i class="fas fa-file-alt font-24 p-3"></i>
                                </a>
                            </div>
                            <div class="col-sm-10">
                                <p class=" fontMS500 font-24">
                                    <a href="" target="_blank" style="color: inherit; text-decoration:none;">

                                    REVISTA CÓLONIDA N°3
                                    </a>
                                </p>
                            </div>
                            <img src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU__LINEA2.jpg" width="100%">
                        </div> -->
                        <div class="row">
                            <div class="col-sm-2">
                                <a href="http://hemeroteca.mariategui.org/index.php/Detail/objects/23" target="_blank"
                                    style="color: inherit; text-decoration:none;">

                                    <i class="fas fa-file-alt font-24 p-3"></i>
                                </a>
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-24">
                                    <a href="http://hemeroteca.mariategui.org/index.php/Detail/objects/23"
                                        target="_blank" style="color: inherit; text-decoration:none;">
                                        REVISTA AMAUTA N°21
                                    </a>
                                </p>
                            </div>
                            <img src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU__LINEA2.jpg" width="100%">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <a href="http://hdl.handle.net/20.500.14428/79081"
                            target="_blank">
                            <img class="imgNP" src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU_IMG023.jpg"
                                width="100%">
                        </a>
                        <p class="fontMS100Italic font-12">
                            Retrato de José María Eguren por Abraham Valdelomar, 1914.
                        </p>
                    </div>
                </div>
                <p class="font-24 mt-5 mb-5">
                    La Biblioteca Nacional del Perú conserva las primeras ediciones de la producción poética de José
                    María Eguren.
                </p>
                <div class="row">
                    <div class="col-sm-4">
                        <a href="https://hdl.handle.net/20.500.14428/11988" target="_blank" style="color: black;">
                            <img class="imgNP" src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU_IMG020.jpg"
                                width="100%">
                        </a>
                    </div>
                    <div class="col-sm-4">
                        <a href="https://hdl.handle.net/20.500.14428/11220" target="_blank" style="color: black;">
                            <img class="imgNP" src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU_IMG021.jpg"
                                width="100%">
                        </a>
                    </div>
                    <div class="col-sm-4">
                        <a href="https://hdl.handle.net/20.500.14428/74694"
                            target="_blank" style="color: black;">
                            <img class="imgNP" src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU_IMG022.jpg"
                                width="100%">
                        </a>
                    </div>
                </div>
                <p class="fontMS300 font-40">
                    <br><br>
                    <span style="line-height: 100%;margin-bottom: 0%;" class="fontMS700">
                        POESÍA CANTADA
                        <img src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU__LINEA2.jpg" width="70%">
                    </span>
                    <br>
                    INTERPRETACIONES MUSICALES
                    <br>
                    DE LOS POEMAS DE JOSÉ MARÍA EGUREN
                    <br><br>
                </p>
                <p class="fontMS100 text-justify font-24">
                    En la revista <span class="fontMS100Italic">Variedades</span> se publicó en 1922 
                    una entrevista a Eguren, en la que el gran vate afirmaba que, de no ser poeta, 
                    le hubiera gustado ser compositor musical.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-2">
                    </div>
                    <div class="col-sm-3">
                        <div class="">
                            <!-- <a href="https://www.youtube.com/watch?v=y9ForvFZkK4" target="_blank" style="color: black;">
                                <p class="fontMS500 font-24">
                                    https://www.youtube.com/watch?v=y9ForvFZkK4
                                </p>
                            </a> -->
                            <audio controls controlsList="nodownload">
                                <source src="/assets/audios/La niña de la lámpara Azul - Jose María Eguren.mp3"
                                    type="audio/mpeg">
                                Your browser does not support the audio element.
                            </audio>
                        </div>
                        <p>
                            <span class="fontMS500 font-24">LA NIÑA DE LA LÁMPARA AZUL</span><br>
                            <span class="fontMS100Italic font-24">José María Eguren</span><br>
                            <span class="fontMS100 font-24">
                                Musicalización y voz: Daniel 'Kiri' Escobar <br>
                                Guitarra: Luis Gonzáles<br>
                                Cajón: María del Carmen Dongo <br>
                                1998-1997
                                <br><br>
                            </span>
                        </p>
                    </div>
                    <div class="col-sm-2">
                    </div>
                    <div class="col-sm-3">
                        <div class="">
                            <!-- <a href="https://www.youtube.com/watch?v=llGL9a33OU8" target="_blank" style="color: black;">
                                <p class="fontMS500 font-24">
                                    https://www.youtube.com/watch?v=llGL9a33OU8
                                </p>
                            </a> -->
                            <audio controls controlsList="nodownload">
                                <source src="/assets/audios/El Duque - Jose María Eguren.mp3" type="audio/mpeg">
                                Your browser does not support the audio element.
                            </audio>
                        </div>
                        <p>
                            <span class="fontMS500 font-24">EL DUQUE</span><br>
                            <span class="fontMS100Italic font-24">José María Eguren</span><br>
                            <span class="fontMS100 font-24">Música: Kiri Escobar</span>
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-2">
                    </div>
                    <div class="col-sm-2">
                    </div>
                    <div class="col-sm-3">
                        <div>
                            <!-- <a href="https://www.youtube.com/watch?v=u9DEEnL84DI" target="_blank" style="color: black;">
                                <p class="fontMS500 font-24">
                                    https://www.youtube.com/watch?v=u9DEEnL84DI
                                </p>
                            </a> -->
                            <audio controls controlsList="nodownload">
                                <source src="/assets/audios/PEREGRÍN José María Eguren.mp3" type="audio/mpeg">
                                Your browser does not support the audio element.
                            </audio>
                        </div>
                        <p>
                            <span class="fontMS500 font-24">PEREGRÍN CAZADOR DE FIGURAS</span><br>
                            <span class="fontMS100Italic font-24">José María Eguren</span><br>
                            <span class="fontMS100 font-24">
                                Musicalización: Juan Luis Dammert<br>
                                Piano: Ramón Rodríguez<br>
                                Guitarra: Waldhy Pedraza<br>
                                Voz: Susana Roel
                            </span>
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-2">
                    </div>
                    <div class="col-sm-3 ">
                        <div class="">
                            <!-- <a href="https://www.youtube.com/watch?v=u9DEEnL84DI" target="_blank" style="color: black;">
                                <p class="fontMS500 font-24">
                                    https://www.youtube.com/watch?v=u9DEEnL84DI
                                </p>
                            </a> -->
                            <audio controls controlsList="nodownload">
                                <source src="/assets/audios/TIZA BLANCA Jose Maria Eguren.mp3" type="audio/mpeg">
                                Your browser does not support the audio element.
                            </audio>
                        </div>
                        <p>
                            <span class="fontMS500 font-24">TIZA BLANCA</span><br>
                            <span class="fontMS100Italic font-24">José María Eguren</span><br>
                            <span class="fontMS100 font-24">
                                Musicalización: Juan Luis Dammert <br>
                                Voz: Jessica Ballón<br>
                                Guitarra: Waldhy Pedraza<br>
                                Cello: Fernando Panizo<br>
                                Flauta: Juan José Martínez<br>
                                Cajón: Raúl Verano
                            </span>
                        </p>
                    </div>
                    <div class="col-sm-2">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoCeleste">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="text-white fontMS500 font-24">
                            Las microfotografías de José María Eguren están envueltas en un halo de misterio e
                            intimidad. La cuidada composición e iluminación de sus elementos puede interpretarse
                            de muchas maneras, una realidad ajena a la nuestra, en la cual somos visitantes. Te
                            invitamos a construir un relato con las fotografías seleccionadas.
                        </p>
                    </div>
                    <div class="col-sm-12 mb-5 mt-4">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            <img width="100%" src="\assets\images\micrositio\micrositio8\ET04_MS011_EGU_IMG024.jpg">
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            <img width="100%" src="\assets\images\micrositio\micrositio8\ET04_MS011_EGU_IMG025.jpg">
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            <img width="100%" src="\assets\images\micrositio\micrositio8\ET04_MS011_EGU_IMG026.jpg">
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="\assets\images\micrositio\micrositio8\ET04_MS011_EGU__LINEA1-recortado.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="\assets\images\micrositio\micrositio8\ET04_MS011_EGU__LINEA1-recortado.png">
                    </div>
                </div>
                <p class="fontMS100 font-24">
                    <br><br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Benavides, M. (2017)<br>
                            </span>
                            <span class="fontMS100Italic text-gris">
                                Naturaleza de la prosa de José María Eguren.<br>
                            </span>
                            <span class="text-gris">
                                Lima: Academia Peruana de la Lengua <br>
                            </span>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=529838" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Núñez, E. (1932)</span><br>
                            <span class="fontMS100Italic text-gris">La poesía de Eguren.</span><br>
                            <span class="text-gris">Lima: Cía. de Impresiones y Publicidad</span><br>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=264474" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Roel, M. (2017)</span><br>
                            <span class="fontMS100Italic text-gris">
                                La obra plástica de José María Eguren en la Biblioteca Nacional del Perú.<br>
                            </span>
                            <span class="text-gris">En: Fénix N° 46 Revista de la Biblioteca Nacional,
                                Lima. p. 165 - 179</span><br>
                            <a href="http://revistafenix.bnp.gob.pe/index.php/fenix/article/view/91/57" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Silva-Santisteban, R. (2005)</span><br>
                            <span class="fontMS100Italic text-gris">El Universo poético de José María Eguren.
                            </span><br>
                            <span class="text-gris">En: José María Eguren. Obra poética motivos.
                                <br> Caracas: Fundación Biblioteca Ayacucho</span><br>
                            <a href="https://biblioteca.org.ar/libros/211555.pdf" target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Wuffarden, L. E. (2017)</span><br>
                            <span class="fontMS100Italic text-gris">José María Eguren. Obra plástica.</span><br>
                            <span class="text-gris">Lima:
                                Biblioteca Abraham Valdelomar y Academia Peruana de la Lengua.</span><br>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=539723" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Footer -->